module.exports = __webpack_public_path__ + "229d7c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/RecommendCard/default.png
// module id = 1136
// module chunks = 2